import React from "react"

import { Flex, Box } from "components/box"

import { PaginationNavigationLink } from "."

type PaginationNavigationProps = {
  componentForLabelNext?: React.ReactNode
  componentForLabelPrev?: React.ReactNode
  handlePrevPageClick: () => void
  handleNextPageClick: () => void
  showPrevBtn: boolean
  showNextBtn: boolean
}

export const PaginationNavigation: React.FC<PaginationNavigationProps> = ({
  handlePrevPageClick,
  handleNextPageClick,
  componentForLabelNext,
  componentForLabelPrev,
  showPrevBtn,
  showNextBtn,
  children
}) => (
  <Flex alignItems="center">
    {showPrevBtn && (
      <Box mr={4}>
        <PaginationNavigationLink onClick={handlePrevPageClick}>
          {componentForLabelPrev ?? "Prev"}
        </PaginationNavigationLink>
      </Box>
    )}
    {children}
    {showNextBtn && (
      <Box ml={4}>
        <PaginationNavigationLink onClick={handleNextPageClick}>
          {componentForLabelNext ?? "Next"}
        </PaginationNavigationLink>
      </Box>
    )}
  </Flex>
)
